import { render, staticRenderFns } from "./ListLogradourotipoPage.vue?vue&type=template&id=132c22a2&"
import script from "./ListLogradourotipoPage.vue?vue&type=script&lang=js&"
export * from "./ListLogradourotipoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports